import captureFocus from "../util/capture-focus"
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default class Modal {

  constructor(element, options) {
    this.element = element
    this.modalContent = this.element.querySelector('.modal__content')

    this.options = {
      ariaHideOnOpenSelectors: [
      ],
      ...options
    }

    this.closeHandler = this.closeHandler.bind(this)
    this.closeTransitionEndHandler = this.closeTransitionEndHandler.bind(this)

    this.escapeHandler = this.escapeHandler.bind(this)
    this.captureFocusHandler = this.captureFocusHandler.bind(this)

    this.handleBackdropClickhandler = this.handleBackdropClickhandler.bind(this)

    this.closeBtn = this.element.querySelector('.modal__close')
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.closeHandler)
    }
  }

  open(triggerElement) {

    this.triggerElement = triggerElement

    disableBodyScroll(this.element, { reserveScrollBarGap: true, })

    // Force the modal element to be scrolled
    // to the top
    setTimeout(() => {
      this.element.scrollTo(0, 0)
    }, 250)

    this.toggleAriaHiddenElements(true)

    document.body.classList.add('modal-open')

    // Since there's a transition for the modal when opening,
    // Apply the modal-open class in requestAnimationFrame
    this.element.classList.add('modal-ready')
    captureFocus(this.element)

    const contentRect = this.modalContent.getBoundingClientRect()
    if (contentRect.height > window.innerHeight) {
      this.element.classList.add('modal-anchor--top')
    }

    requestAnimationFrame(() => {
      this.element.classList.add('modal-open')
    })

    document.body.addEventListener('keyup', this.escapeHandler)
    document.body.addEventListener('keydown', this.captureFocusHandler)

    this.element.dispatchEvent(new CustomEvent('open'))

    setTimeout(() => {
      document.body.addEventListener('click', this.handleBackdropClickhandler)
    })
  }

  close() {

    if (!this.element.classList.contains('modal-open')) {
      return;
    }

    document.body.classList.remove('modal-open')

    enableBodyScroll(this.element)
    this.toggleAriaHiddenElements(false)

    this.element.addEventListener('transitionend', this.closeTransitionEndHandler)
    this.element.classList.remove('modal-open')
    this.element.classList.remove('modal-anchor--top')

    if (this.triggerElement) {
      this.triggerElement.focus()
    }

    this.element.dispatchEvent(new CustomEvent('close'))

    document.body.removeEventListener('keyup', this.escapeHandler)
    document.body.removeEventListener('keydown', this.captureFocusHandler)
    document.body.removeEventListener('click', this.handleBackdropClickhandler)
  }

  closeHandler() {
    this.close()
  }

  closeTransitionEndHandler(e) {
    if (e.target.closest('.modal-ready')) {
      this.element.classList.remove('modal-ready')
      this.element.removeEventListener('transitionend', this.closeTransitionEndHandler)
    }
  }

  escapeHandler(e) {
    if (typeof e.key !== 'undefined' && e.key.toLowerCase() == 'escape') {
      this.close()
    }
  }

  captureFocusHandler(e) {

    if (typeof e.key !== 'undefined' && e.key.toLowerCase() == 'tab') {
      captureFocus(this.element, e)
    }
  }

  toggleAriaHiddenElements(open) {

    if (this.options && typeof this.options.ariaHideOnOpenSelectors !== 'undefined') {
      this.options.ariaHideOnOpenSelectors.forEach((selector) => {
        let ariaElem = document.querySelector(selector)
        if (ariaElem) {
          ariaElem.setAttribute('aria-hidden', open ? 'true' : 'false')
        }
      })
    }

    this.element.setAttribute('aria-hidden', open ? 'false' : 'true')
  }

  handleBackdropClickhandler(event) {
    if (!event.target.closest('.modal__content')) {
      this.close()
    }
  }
}
